<div class="wrapper" #dropdownEl>
  <div class="title">
    {{title}}
    <button class="btn btn-link p-0 mobile-btn-close" (click)="closeClick($event)">
      <i class="fa fa-close"></i>
    </button>
  </div>
  <div *ngIf="!items || items.length <=0" class="btn-group" role="group" aria-label="Basic example">
    <button (click)="onSelect('L', $event)" type="button" class="btn btn-outline-secondary"
      [ngClass]="{ 'btn-success' : selected['L']}" [disabled]="disabled">
      Low
      <div *ngIf="facets && facets[param] && facets[param]['L']">
        ({{facets[param]['L'] | roundsig }})
      </div>
    </button>
    <button (click)="onSelect('M', $event)" type="button" class="btn btn-outline-secondary"
      [ngClass]="{ 'btn-warning' : selected['M']}" [disabled]="disabled">
      Medium
      <div *ngIf="facets && facets[param] && facets[param]['M']">
        ({{facets[param]['M'] | roundsig }})
      </div>
    </button>
    <button (click)="onSelect('H', $event)" type="button" class="btn btn-outline-secondary"
      [ngClass]="{ 'btn-danger' : selected['H']}" [attr.disabled]="disabled">
      High
      <div *ngIf="facets && facets[param] && facets[param]['H']">
        ({{facets[param]['H'] | roundsig }})
      </div>
    </button>
  </div>
  <div *ngIf="items && items.length >0" class="btn-group" role="group" aria-label="Basic example">
    <button *ngFor="let item of items" (click)="onSelect2(item, $event)" type="button" class="btn" [disabled]="disabled"
      [ngClass]="{
        'btn-outline-secondary' : !item.selected,
        'btn-secondary' : item.selected && (item.value === 'T' || item.value === 'F'),
        'btn-success' : item.selected && item.value === 'L',
        'btn-warning' : item.selected && item.value === 'M',
        'btn-danger' : item.selected && item.value === 'H',
        'btn-critical' : item.selected && item.value === 'C',
        'disabled' : !noFacets && (!facets || !facets[param] || !facets[param][item.value] || facets[param][item.value]<= 0)} ">
      {{item.name}}
      <div *ngIf="facets && facets[param] && facets[param][item.value]">
        <span class="facet" *ngIf="facets[param][item.value] > 9999">({{facets[param][item.value] | roundsig }})</span>
        <span class="facet" *ngIf="facets[param][item.value] <= 9999">({{facets[param][item.value] | num }})</span>
      </div>
      <div [hidden]="noFacets" *ngIf="!facets || !facets[param] || !facets[param][item.value]">
        <span class="facet">(0)</span>
      </div>
    </button>
  </div>
</div>